import { useLanguage } from './LanguageContext';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Globe } from 'lucide-react';

export function LanguageSelector({ className = "" }) {
  const { language, changeLanguage, LANGUAGES } = useLanguage();

  return (
    <Select value={language} onValueChange={changeLanguage}>
      <SelectTrigger className={`w-[140px] bg-secondary/50 border-border/50 ${className}`}>
        <Globe className="h-4 w-4 mr-2 text-muted-foreground" />
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {LANGUAGES.map((lang) => (
          <SelectItem key={lang.code} value={lang.code}>
            <span className="flex items-center gap-2">
              <span>{lang.flag}</span>
              <span>{lang.name}</span>
            </span>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}

// Compact version for mobile/header
export function LanguageSelectorCompact({ className = "" }) {
  const { language, changeLanguage, LANGUAGES } = useLanguage();
  const currentLang = LANGUAGES.find(l => l.code === language);

  return (
    <Select value={language} onValueChange={changeLanguage}>
      <SelectTrigger className={`w-[70px] bg-secondary/50 border-border/50 ${className}`}>
        <SelectValue>
          <span className="text-lg">{currentLang?.flag}</span>
        </SelectValue>
      </SelectTrigger>
      <SelectContent>
        {LANGUAGES.map((lang) => (
          <SelectItem key={lang.code} value={lang.code}>
            <span className="flex items-center gap-2">
              <span className="text-lg">{lang.flag}</span>
              <span>{lang.name}</span>
            </span>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
